export interface LocalStorageItem {
  ttl: Date;
}

export const recentlyViewedKey = 'recently_viewed';

export function setLocalStorageItem(key: string, value: string | LocalStorageItem) {
  if (typeof value === 'string' || typeof value === 'undefined') {
    // LS item to be set has already been converted to a string
    localStorage?.setItem(key, value);
  } else {
    value.ttl = new Date();
    localStorage?.setItem(key, JSON.stringify(value));
  }
}

export function getLocalStorageItem(key: string) {
  const val = localStorage?.getItem(key);
  if (!val) {
    return null;
  }
  try {
    const parsed = JSON.parse(val);
    return parsed;
  } catch {
    // string is not a json object, return by itself
    return val;
  }
}

export function removeLocalStorageItem(key: string) {
  localStorage?.removeItem(key);
}
